import { Form, useFormikContext } from 'formik'
import { Button } from '@mui/material'

import { UsersSearchInput } from '../account-users/invite-modal/user-search-input.component'

import { useStyles } from './styles'
import { HelperWrapper } from 'src/components/helper-wrapper'

export const OwnerChangeContent = () => {
  const classes = useStyles()
  const { isSubmitting } = useFormikContext()

  return (
    <Form className={classes.content}>
      <UsersSearchInput />
      <Button variant="contained" type="submit" disabled={isSubmitting}>
        <HelperWrapper t="account-role-change-btn" />
      </Button>
    </Form>
  )
}
